<template>
  <div class="p-m-3 sp-page">
    <MockBanner />
    <div class="sp-row">
      <h2 style="margin: 0;">Sites</h2>
      <span class="sp-spacer"></span>
      <span class="p-input-icon-left">
        <i class="pi pi-search" />
        <InputText v-model="search" placeholder="Search site, street, town, postcode..." style="width: 20rem;" />
      </span>
      <Button label="Add site" icon="pi pi-plus" class="p-button-success" @click="formVisible = true" />
    </div>
    <p class="sp-sub">One row per site (one address). Open a site to see its projects and everyone quoting on it.</p>

    <div class="p-card p-p-3">
      <DataTable
        :value="rows"
        :autoLayout="true"
        class="p-datatable-sm p-datatable-striped p-datatable-gridlines"
        :rowHover="true"
        @row-click="e => open(e.data.id)"
      >
        <Column field="name" header="Site" :sortable="true">
          <template #body="s"><span class="sp-link">{{ s.data.name }}</span></template>
        </Column>
        <Column field="address" header="Address" :sortable="true" />
        <Column field="town" header="Town" :sortable="true" />
        <Column field="postCode" header="Postcode" :sortable="true" />
        <Column field="nProjects" header="Projects" :sortable="true" bodyStyle="text-align: right;" />
        <Column field="nEnquiries" header="Enquiries" :sortable="true" bodyStyle="text-align: right;" />
        <Column field="nCustomers" header="Customers" :sortable="true" bodyStyle="text-align: right;" />
        <Column field="nLive" header="Live projects" :sortable="true" bodyStyle="text-align: right;" />
        <Column field="counted" header="Project-basis value £" :sortable="true">
          <template #body="s"><div class="sp-money">{{ money(s.data.counted) }}</div></template>
        </Column>
        <Column field="liveSum" header="Live quotes added up £" :sortable="true">
          <template #body="s"><div class="sp-money sp-muted">{{ money(s.data.liveSum) }}</div></template>
        </Column>
        <Column field="created" header="Created" :sortable="true" />
      </DataTable>
    </div>

    <SiteForm v-if="formVisible" :visible="formVisible" @close="formVisible = false" @picked="onPicked" />
  </div>
</template>

<script>
import MockBanner from './MockBanner.vue'
import SiteForm from './SiteForm.vue'
import { sites, projectsOfSite, projectTotals, projectStatus, money } from './mockData'

export default {
  name: 'SpSites',
  components: { MockBanner, SiteForm },
  data() { return { search: '', formVisible: false, version: 0 } },
  computed: {
    rows() {
      this.version
      const q = this.search.toUpperCase()
      return sites
        .map(s => {
          const ps = projectsOfSite(s.id)
          const totals = ps.map(p => projectTotals(p.id))
          return {
            ...s,
            address: [s.address1, s.address2].filter(Boolean).join(', '),
            nProjects: ps.length,
            nEnquiries: totals.reduce((a, t) => a + t.nEnquiries, 0),
            nCustomers: totals.reduce((a, t) => a + t.nCustomers, 0),
            nLive: ps.filter(p => projectStatus(p.id) === 'Live').length,
            counted: totals.reduce((a, t) => a + t.counted, 0),
            liveSum: totals.reduce((a, t) => a + t.liveSum, 0)
          }
        })
        .filter(r => !q || [r.name, r.address, r.town, r.postCode].join(' ').toUpperCase().includes(q))
    }
  },
  methods: {
    money,
    open(id) { this.$router.push('/sitesProjects/sites/' + id) },
    onPicked(site) { this.formVisible = false; this.version++; this.open(site.id) }
  }
}
</script>

<style scoped>
@import './sitesProjects.css';
</style>
